import React, { useEffect, useState } from "react";
import axios from "axios";
import { baseUrl } from "../Components/baseUrl";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { translation } from "../Components/Translation";

const Cart = () => {
    const navigate = useNavigate();
    const [lang, setLang] = useState(localStorage.getItem("lang") || "fa");
    let token;
    if (typeof window !== "undefined") {
        token = localStorage.getItem("token");
    }
    useEffect(() => {
        document.title = "ویزیت | سبد خرید";
        token == null && navigate("/login", { replace: true });
    }, []);

    return (
        <div>
            <div className="container">
                <div className="cart-main">
                    <h1>
                        {translation.Cart[lang]
                            ? translation.Cart[lang]
                            : "سبد خرید"}
                    </h1>
                    <div className="shapes">
                        <div className="shape-row">
                            <div
                                className="square pink"
                                onClick={() =>
                                    navigate("/panel/orders/ongoing")
                                }
                            >
                                <svg
                                    width="80"
                                    height="80"
                                    viewBox="0 0 80 80"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        opacity="0.4"
                                        d="M40.0001 73.3334C58.4096 73.3334 73.3334 58.4096 73.3334 40.0001C73.3334 21.5906 58.4096 6.66675 40.0001 6.66675C21.5906 6.66675 6.66675 21.5906 6.66675 40.0001C6.66675 58.4096 21.5906 73.3334 40.0001 73.3334Z"
                                        fill="#FF83AF"
                                    />
                                    <path
                                        d="M52.3667 53.1001C51.9334 53.1001 51.5 53.0001 51.1 52.7334L40.7667 46.5668C38.2 45.0334 36.3 41.6668 36.3 38.7001V25.0334C36.3 23.6668 37.4334 22.5334 38.8 22.5334C40.1667 22.5334 41.3 23.6668 41.3 25.0334V38.7001C41.3 39.9001 42.3 41.6668 43.3334 42.2668L53.6667 48.4334C54.8667 49.1334 55.2334 50.6668 54.5334 51.8668C54.0334 52.6668 53.2 53.1001 52.3667 53.1001Z"
                                        fill="#FF83AF"
                                    />
                                </svg>
                                <span>
                                    {translation.Cart_Ongoing[lang]
                                        ? translation.Cart_Ongoing[lang]
                                        : "در دست اقدام"}
                                </span>
                            </div>
                            <div
                                className="rec yellow"
                                onClick={() =>
                                    navigate("/panel/orders/new_orders")
                                }
                            >
                                <span>
                                    {translation.New_orders_New[lang]
                                        ? translation.New_orders_New[lang]
                                        : "سفارشات جدید"}
                                </span>
                                <svg
                                    width="80"
                                    height="80"
                                    viewBox="0 0 80 80"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M54.1666 74.9999C57.3882 74.9999 59.9999 72.3882 59.9999 69.1666C59.9999 65.9449 57.3882 63.3333 54.1666 63.3333C50.9449 63.3333 48.3333 65.9449 48.3333 69.1666C48.3333 72.3882 50.9449 74.9999 54.1666 74.9999Z"
                                        fill="#D7B653"
                                    />
                                    <path
                                        d="M27.5001 74.9999C30.7217 74.9999 33.3334 72.3882 33.3334 69.1666C33.3334 65.9449 30.7217 63.3333 27.5001 63.3333C24.2784 63.3333 21.6667 65.9449 21.6667 69.1666C21.6667 72.3882 24.2784 74.9999 27.5001 74.9999Z"
                                        fill="#D7B653"
                                    />
                                    <path
                                        opacity="0.4"
                                        d="M16.1334 13.1334L15.4667 21.3001C15.3334 22.8667 16.5668 24.1667 18.1334 24.1667H69.1667C70.5667 24.1667 71.7334 23.1001 71.8334 21.7001C72.2668 15.8001 67.7667 11.0001 61.8667 11.0001H20.9667C20.6334 9.53342 19.9667 8.1334 18.9334 6.96674C17.3001 5.20007 14.9668 4.16675 12.5668 4.16675H6.66675C5.30008 4.16675 4.16675 5.30008 4.16675 6.66675C4.16675 8.03341 5.30008 9.16675 6.66675 9.16675H12.4668C13.5001 9.16675 14.4668 9.6001 15.1668 10.3334C15.8668 11.1001 16.2001 12.1001 16.1334 13.1334Z"
                                        fill="#D7B653"
                                    />
                                    <path
                                        d="M68.3665 29.1667H17.2332C15.8332 29.1667 14.6999 30.2334 14.5665 31.6001L13.3665 46.1001C12.8999 51.7668 17.3665 56.6667 23.0665 56.6667H60.1332C65.1332 56.6667 69.5332 52.5668 69.8999 47.5668L70.9999 32.0001C71.1332 30.4668 69.9332 29.1667 68.3665 29.1667Z"
                                        fill="#D7B653"
                                    />
                                </svg>
                            </div>
                        </div>
                        <div className="shape-row">
                            <div
                                className="rec green"
                                onClick={() =>
                                    navigate("/panel/orders/confirmed")
                                }
                            >
                                <span>
                                    {translation.Cart_Confirmed[lang]
                                        ? translation.Cart_Confirmed[lang]
                                        : "سفارشات تایید شده"}
                                </span>
                                <svg
                                    width="80"
                                    height="80"
                                    viewBox="0 0 80 80"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        opacity="0.4"
                                        d="M35.8333 8.16665C38.1333 6.19998 41.9 6.19998 44.2333 8.16665L49.5 12.7C50.5 13.5667 52.3667 14.2667 53.7 14.2667H59.3667C62.9 14.2667 65.8 17.1667 65.8 20.7V26.3666C65.8 27.6667 66.5 29.5667 67.3667 30.5667L71.9 35.8333C73.8667 38.1333 73.8667 41.9 71.9 44.2333L67.3667 49.5C66.5 50.5 65.8 52.3667 65.8 53.7V59.3667C65.8 62.9 62.9 65.8 59.3667 65.8H53.7C52.4 65.8 50.5 66.5 49.5 67.3666L44.2333 71.9C41.9333 73.8667 38.1667 73.8667 35.8333 71.9L30.5667 67.3666C29.5667 66.5 27.7 65.8 26.3667 65.8H20.6C17.0667 65.8 14.1667 62.9 14.1667 59.3667V53.6667C14.1667 52.3667 13.4667 50.5 12.6333 49.5L8.13335 44.2C6.20002 41.9 6.20002 38.1667 8.13335 35.8667L12.6333 30.5667C13.4667 29.5667 14.1667 27.7 14.1667 26.4V20.6666C14.1667 17.1333 17.0667 14.2333 20.6 14.2333H26.3667C27.6667 14.2333 29.5667 13.5333 30.5667 12.6667L35.8333 8.16665Z"
                                        fill="#6BBD4E"
                                    />
                                    <path
                                        d="M35.9668 50.5668C35.3001 50.5668 34.6668 50.3001 34.2001 49.8334L26.1334 41.7668C25.1668 40.8001 25.1668 39.2001 26.1334 38.2334C27.1001 37.2668 28.7001 37.2668 29.6668 38.2334L35.9668 44.5334L50.3001 30.2001C51.2668 29.2334 52.8668 29.2334 53.8334 30.2001C54.8001 31.1668 54.8001 32.7668 53.8334 33.7334L37.7334 49.8334C37.2668 50.3001 36.6334 50.5668 35.9668 50.5668Z"
                                        fill="#6BBD4E"
                                    />
                                </svg>
                            </div>
                            <div
                                className="square blue"
                                onClick={() =>
                                    navigate("/panel/orders/returned")
                                }
                            >
                                <svg
                                    width="80"
                                    height="80"
                                    viewBox="0 0 80 80"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        opacity="0.4"
                                        d="M49.6667 6.66675H30.3334C28.0668 6.66675 24.8667 8.0001 23.2667 9.6001L9.6001 23.2668C8.0001 24.8668 6.66675 28.0668 6.66675 30.3334V49.6667C6.66675 51.9334 8.0001 55.1334 9.6001 56.7334L23.2667 70.4001C24.8667 72.0001 28.0668 73.3334 30.3334 73.3334H49.6667C51.9334 73.3334 55.1334 72.0001 56.7334 70.4001L70.4001 56.7334C72.0001 55.1334 73.3334 51.9334 73.3334 49.6667V30.3334C73.3334 28.0668 72.0001 24.8668 70.4001 23.2668L56.7334 9.6001C55.1334 8.0001 51.9334 6.66675 49.6667 6.66675Z"
                                        fill="#5AD4F0"
                                    />
                                    <path
                                        d="M43.5335 40.0001L53.4335 30.1001C54.4001 29.1335 54.4001 27.5335 53.4335 26.5668C52.4668 25.6001 50.8668 25.6001 49.9001 26.5668L40.0001 36.4668L30.1001 26.5668C29.1335 25.6001 27.5335 25.6001 26.5668 26.5668C25.6001 27.5335 25.6001 29.1335 26.5668 30.1001L36.4668 40.0001L26.5668 49.9001C25.6001 50.8668 25.6001 52.4668 26.5668 53.4335C27.0668 53.9335 27.7001 54.1668 28.3335 54.1668C28.9668 54.1668 29.6001 53.9335 30.1001 53.4335L40.0001 43.5335L49.9001 53.4335C50.4001 53.9335 51.0335 54.1668 51.6668 54.1668C52.3001 54.1668 52.9335 53.9335 53.4335 53.4335C54.4001 52.4668 54.4001 50.8668 53.4335 49.9001L43.5335 40.0001Z"
                                        fill="#5AD4F0"
                                    />
                                </svg>

                                <span>
                                    {translation.Cart_returns[lang]
                                        ? translation.Cart_returns[lang]
                                        : "مرجوعی ها"}
                                </span>
                            </div>
                        </div>
                        <div className="shape-row">
                            <div
                                className="rec rec-49 pur"
                                onClick={() =>
                                    navigate("/panel/orders/pay_list")
                                }
                            >
                                <svg
                                    width="80"
                                    height="80"
                                    viewBox="0 0 80 80"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M16.6666 50C13.5333 50 10.6333 51.1 8.33325 52.9333C5.26659 55.3667 3.33325 59.1333 3.33325 63.3333C3.33325 65.8333 4.03326 68.2 5.26659 70.2C7.56659 74.0667 11.7999 76.6667 16.6666 76.6667C20.0333 76.6667 23.0999 75.4333 25.4333 73.3333C26.4666 72.4667 27.3666 71.4 28.0666 70.2C29.2999 68.2 29.9999 65.8333 29.9999 63.3333C29.9999 55.9667 24.0333 50 16.6666 50ZM23.5666 61.9L16.4666 68.4666C15.9999 68.8999 15.3666 69.1333 14.7666 69.1333C14.1332 69.1333 13.4999 68.9001 12.9999 68.4001L9.69993 65.1001C8.73326 64.1334 8.73326 62.5332 9.69993 61.5666C10.6666 60.5999 12.2666 60.5999 13.2333 61.5666L14.8332 63.1667L20.1666 58.2332C21.1666 57.2999 22.7666 57.3667 23.6999 58.3667C24.6333 59.3667 24.5666 60.9667 23.5666 61.9Z"
                                        fill="#7391F7"
                                    />
                                    <path
                                        opacity="0.4"
                                        d="M64.9332 43.1666H71.6666V38.3666C71.6666 31.4666 66.0333 25.8333 59.1333 25.8333H20.8666C13.9666 25.8333 8.33325 31.4666 8.33325 38.3666V52.9333C10.6333 51.0999 13.5333 49.9999 16.6666 49.9999C24.0333 49.9999 29.9999 55.9666 29.9999 63.3333C29.9999 65.8333 29.2999 68.1999 28.0666 70.1999C27.3666 71.3999 26.4666 72.4666 25.4333 73.3333H59.1333C66.0333 73.3333 71.6666 67.6999 71.6666 60.7999V56.8332H65.3333C61.7333 56.8332 58.4333 54.1999 58.1333 50.5999C57.9333 48.4999 58.7332 46.5332 60.1332 45.1665C61.3666 43.8999 63.0666 43.1666 64.9332 43.1666Z"
                                        fill="#7391F7"
                                    />
                                    <path
                                        d="M49.4999 13.1666V25.8332H20.8666C13.9666 25.8332 8.33325 31.4666 8.33325 38.3666V26.1333C8.33325 22.1666 10.7666 18.6332 14.4666 17.2332L40.9332 7.23316C45.0666 5.69983 49.4999 8.73326 49.4999 13.1666Z"
                                        fill="#7391F7"
                                    />
                                    <path
                                        d="M75.2001 46.5666V53.4335C75.2001 55.2668 73.7334 56.7667 71.8668 56.8333H65.3335C61.7335 56.8333 58.4334 54.2 58.1334 50.6C57.9334 48.5 58.7334 46.5333 60.1334 45.1667C61.3667 43.9 63.0668 43.1667 64.9334 43.1667H71.8668C73.7334 43.2334 75.2001 44.7333 75.2001 46.5666Z"
                                        fill="#7391F7"
                                    />
                                    <path
                                        d="M46.6666 42.5H23.3333C21.9666 42.5 20.8333 41.3667 20.8333 40C20.8333 38.6333 21.9666 37.5 23.3333 37.5H46.6666C48.0333 37.5 49.1666 38.6333 49.1666 40C49.1666 41.3667 48.0333 42.5 46.6666 42.5Z"
                                        fill="#7391F7"
                                    />
                                </svg>
                                <span>
                                    {translation.Cart_List[lang]
                                        ? translation.Cart_List[lang]
                                        : "لیست پرداختی ها"}
                                </span>
                            </div>
                            <div
                                className="rec rec-49 red"
                                onClick={() =>
                                    navigate("/panel/orders/canceled")
                                }
                            >
                                <svg
                                    width="80"
                                    height="80"
                                    viewBox="0 0 80 80"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        opacity="0.4"
                                        d="M40.0001 73.3334C58.4096 73.3334 73.3334 58.4096 73.3334 40.0001C73.3334 21.5906 58.4096 6.66675 40.0001 6.66675C21.5906 6.66675 6.66675 21.5906 6.66675 40.0001C6.66675 58.4096 21.5906 73.3334 40.0001 73.3334Z"
                                        fill="#FF6D6D"
                                    />
                                    <path
                                        d="M43.5333 40L51.2 32.3333C52.1666 31.3666 52.1666 29.7666 51.2 28.8C50.2333 27.8333 48.6333 27.8333 47.6666 28.8L40 36.4666L32.3333 28.8C31.3666 27.8333 29.7666 27.8333 28.8 28.8C27.8333 29.7666 27.8333 31.3666 28.8 32.3333L36.4666 40L28.8 47.6666C27.8333 48.6333 27.8333 50.2333 28.8 51.2C29.3 51.7 29.9333 51.9333 30.5666 51.9333C31.2 51.9333 31.8333 51.7 32.3333 51.2L40 43.5333L47.6666 51.2C48.1666 51.7 48.8 51.9333 49.4333 51.9333C50.0666 51.9333 50.7 51.7 51.2 51.2C52.1666 50.2333 52.1666 48.6333 51.2 47.6666L43.5333 40Z"
                                        fill="#FF6D6D"
                                    />
                                </svg>
                                <span>
                                    {translation.Cart_Canceled[lang]
                                        ? translation.Cart_Canceled[lang]
                                        : "سفارشات کنسل شده"}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Cart;
